<template>
    <div >
        <div class="logo-area">
            <img :src="imgLogo" alt="" class="input-addon">
        </div>
        <div class="title-area">注册会员</div>
        <form class="form-area" action="">
            <div class="form-row register-row">
                <span class="register-title">姓名<span style="color:#FF0000;">*</span></span>
                <span class="register-colon">:</span>
                <input v-model="name" type="text" @blur="fixScroll" class="register-inp" placeholder='请输入姓名' maxlength="10">
            </div>
            <div class="form-row register-row">
                <span class="register-title">手机号<span style="color:#FF0000;">*</span></span>
                <span class="register-colon">:</span>
                <input v-model="cellphone" type="text" @blur="fixScroll" class="register-inp" placeholder='请输入手机号' maxlength="11">
            </div>
            <div class="form-row register-row">
                <span class="register-title">出生日期<span style="color:#FF0000;">*</span></span>
                <span class="register-colon">:</span>
                <input v-model="birthday" type="text" class="register-inp" placeholder='请输入出生日期' maxlength="11" readonly @click="dateSwitch = true">
                <img :src="imgPicker" alt="" @click="dateSwitch = true" class="input-addon">
            </div>
            <div class="form-row register-row">
                <span class="register-title">身份证号<span style="color:#FF0000;">*</span></span>
                <span class="register-colon">:</span>
                <input v-model="idNo" type="text" @blur="fixScroll" class="register-inp" placeholder='请输入身份证号' maxlength="18">
                <img :src="imgHelp" @click="showTips" alt="" class="input-addon">
            </div>
            <div class="form-row register-row">
                <span class="register-title">护照号</span>
                <span class="register-colon">:</span>
                <input v-model="passportNo" type="text" @blur="fixScroll" class="register-inp" placeholder='请输入护照号' maxlength="24">
                <img :src="imgHelp" @click="showTips" alt="" class="input-addon">
            </div>
            <div class="submit-row register-row">
                <span class="btn-register" @click="submit">提交</span>
            </div>
        </form>
        <q-dialog v-model="dateSwitch" position="bottom">
            <q-date
                v-model = "birthday"
                mask = "YYYY-MM-DD"
                minimal
            />
        </q-dialog>
    </div>
</template>

<script>
import logoSrc from '@/style/image/register_logo.png';
import helpSrc from '@/style/image/help.png';
import pickerSrc from '@/style/image/picker.png';
import bgSrc from '@/style/image/register_bg.png';
import ajax from '@/utils/ajax';
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import validate from '@/utils/validate';
import router from '@/router';

export default {
    name: 'home',
    components: {
        Layout,
    },
    data() {
        return {
            lang: getLang(),
            dateSwitch: false,
            imgLogo: logoSrc,
            imgHelp: helpSrc,
            imgPicker: pickerSrc,
            imgBg: bgSrc,
            name: '',
            cellphone: '',
            birthday: '',
            idNo: '',
            passportNo: '',
        };
    },
    mounted() {

    },
    methods: {
        goBack() {
            router.go(-1);
        },
        submit() {
            if (validate.judge(this.name, 'require') !== true) {
                this.$q.dialog({ title: '请填写姓名', message: '' });
            } else if (validate.judge(this.cellphone, ['require', 'cellphone']) !== true) {
                this.$q.dialog({ title: '请填写正确的手机号', message: '' });
            } else if (validate.judge(this.birthday, ['require']) !== true) {
                this.$q.dialog({ title: '请选择出生日期', message: '' });
            } else if (validate.judge(this.idNo, ['require', 'identity']) !== true) {
                this.$q.dialog({ title: '请填写正确的身份证号', message: '' });
            } else if (validate.judge(this.passportNo, ['normal']) !== true) {
                this.$q.dialog({ title: '请填写正确的护照号', message: '' });
            } else {
                ajax.post('/web/wx/register.json', {
                    name: this.name,
                    cellphone: this.cellphone,
                    birthday: this.birthday,
                    idNo: this.idNo,
                    passportNo: this.passportNo,
                }).then(() => {
                    this.$q.dialog({ title: '', message: '注册成功，您已成为我们的注册会员！' }).onDismiss(() => {
                        this.goBack();
                    });
                }).catch((info) => {
                    this.$q.dialog({ title: '', message: info.message });
                });
            }
        },
        showTips() {
            this.$q.dialog({ title: '', message: '为了保证您有更好地服务体验，所有的服务均为实名制，我们将确保每一位会员的隐私不被泄露。' });
        },
        fixScroll(event) {
            const top = event.target.getBoundingClientRect().top + document.documentElement.scrollTop;
            document.documentElement.scrollTop = top;
        },
    },
};
</script>
<style>
    body { background: url('../../style/image/register_bg.png') 50% 0 no-repeat; background-size: cover; }
</style>

<style lang="less" scoped>
    .logo-area {
        padding: 40px 0 22px;
        text-align: center;
        img {
            width: 53px;
            height: 62px;
        }
    }
    .title-area {
        color: #C0A47F;
        font-size: 18px;
        text-align: center;
        font-weight: 600;
    }
    .form-area {
        padding: 20px 0 0;
    }
    .form-row {
        position: relative;
        margin: 18px 0 78px 0 106px;
        height: 30px;
        line-height: 20px;
        border-bottom: 1px #fff solid;
        &.register-row {
            margin: 18px 64px 0 122px;
            border-bottom: 1px #C0A47F solid;
        }
        .register-inp {
            display: inline-block;
            width: 100%;
            height: 30px;
            line-height: 30px;
            border: 0;
            color: #626262;
            background: transparent;
            text-indent: 10px;
        }
        .register-title {
            position: absolute;
            top: 0;
            left: -82px;
            width: 70px;
            height: 30px;
            line-height: 30px;
            text-align: justify;
            text-align-last: justify;
            color: #626262;
        }
        .register-colon {
            position: absolute;
            top: 0;
            left: -10px;
            height: 30px;
            line-height: 30px;
            text-align: left;
            color: #626262;
        }
        .long-inp {
            display: inline-block;
            width: 100%;
            height: 30px;
            line-height: 30px;
            border: 0;
            color: #fff;
            background: transparent;
            text-indent: 10px;
        }
        .row-title {
            position: absolute;
            top: 0;
            left: -56px;
            width: 45px;
            height: 30px;
            line-height: 30px;
            text-align: justify;
            text-align-last: justify;
            color: #fff;
        }
        .row-colon {
            position: absolute;
            top: 0;
            left: -10px;
            height: 30px;
            line-height: 30px;
            text-align: left;
            color: #fff;
        }
        .input-addon {
            position: absolute;
            margin-left: 02px;
            padding: 10px 38px 10px 0;
            top: 0;
            left: 100%;
            width: 50px;
            text-align: right;
            color: #fff;
        }
    }
    .submit-row {
        text-align: center;
        margin-top: 28px;
        padding-bottom: 20px;
        &.register-row {
            margin-top: 56px;
        }
        .btn-block {
            display:inline-block;
            background-color: #3DBBED;
            color: #fff;
            width: 164px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 16px;
            letter-spacing: 1px;
        }
        .btn-register {
            display:inline-block;
            background-color: #C0A47F;
            color: #fff;
            width: 210px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            border-radius: 22px;
            letter-spacing: 1px;
        }
    }
</style>
